define(["dojo-proxy-loader?name=dojo/_base/declare!/home/jenkins/agent/workspace/mailchimp-cd/MC-Mono-Build/node_modules/@mc/webpack-plugin-legacy-dojo/src/modules/noop-module", "mojo/page/shouldTrack"], function (declare, shouldTrack) {
  return declare([], {
    constructor: function (params) {
      if (!shouldTrack()) {
        return;
      }
      if (params.webEngagementEndpoint) {
        window.mc_website_engagement_endpoint = params.webEngagementEndpoint;
      }
      if (params.webEngagementTrackingEndpoint) {
        window.mc_website_engagement_tracking_endpoint = params.webEngagementTrackingEndpoint;
      }
      var script = document.createElement("script");
      script.id = "mcjs";
      script.async = true;
      script.src = params.scriptUrl;
      var first_script = document.getElementsByTagName("script")[0];
      if (first_script && first_script.parentNode) {
        first_script.parentNode.insertBefore(script, first_script);
      } else {
        document.head.appendChild(script);
      }
    }
  });
});